<template>
  <div class="wia-container">
    <div class="wia-box">
      <h2 class="wia-title">{{ config.i18n.wia_all_categories }}</h2>
      <div class="wia-categories">
        <a class="wia-category" :href="allLink + '--category-issue?cat='+category.id + '&name='+category.description" v-for="category in categoriesOptions" v-bind:key="category.id">
          {{ category.description }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {filterAllowedCategories} from '@/helpers/allowedCategoriesFilter'

export default {
  name: 'WIA-Categories',
  title: 'WIA Category Selection',
  description: 'WIA Category Selection',
  meta: {
    name: 'robots',
    content: 'noindex'
  },
  data () {
    return {
      categorySelected: null,
      categoriesOptions: [],
      modelSelected: null,
      searchText: null,
      allLink: null
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    config: function () {
      return this.$store.state.config
    },
    detail: function () {
      return this.$store.state.details
    }
  },
  methods: {
  },
  mounted () {
    this.allLink = document.location.pathname.replace(/\/$/, '')
    this.allLink = this.allLink.replace('/--all-categories', '/')
    // /product_line/{language}
    this.$http.get(this.$store.state.config.endpoint + '/product_line/' + this.$store.state.config.language.toLowerCase()).then(
      result => {
        this.categoriesOptions = filterAllowedCategories(
          result.body,
          this.$store.state.config.brand.toLowerCase(),
          this.$store.state.config.language.toLowerCase()
        )
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../../style/main';

.brand-theme-id {

}

.wia-categories {
  max-width: 68rem;
  margin: 0 auto;
}

.wia-category {
  display: block;
  width: 100%;
  text-decoration: underline;
  margin-bottom: 5px;
}

.brand-theme-hp {
}

.brand-theme-bk {
}

.brand-theme-wp {
}

.brand-theme-mb {
}

</style>
